import { useEffect, useState } from 'react';

// eslint-disable-next-line import/no-extraneous-dependencies
import * as braze from '@braze/web-sdk';

const useBraze = () => {
    const [isBrazeInitialized, setIsBrazeInitialized] = useState(false);

    useEffect(() => {
        const brazeOptions = {
            apiKey: process.env.REACT_APP_BRAZE_API_KEY as string,
            baseUrl: process.env.REACT_APP_BRAZE_BASE_URL as string,
            enableLogging: process.env.NODE_ENV === 'development',
        };

        if (!isBrazeInitialized) {
            braze.initialize(brazeOptions.apiKey, {
                baseUrl: brazeOptions.baseUrl,
                enableLogging: brazeOptions.enableLogging,
            });
            braze.openSession();
            setIsBrazeInitialized(true);
        }
    }, [isBrazeInitialized]);

    return isBrazeInitialized;
};

export default useBraze;
